import React, { useEffect, useState } from "react";
import { VideoIframe, VideoModal, FCNProfileHeader, NewsFeedComponent, MyMeetings, SearchAllocatorsCard } from "@hedgefund/shared";
import { useDispatch, useSelector } from "react-redux";
import { Button, CardWithLable, Input, Spinner, Table } from "@public/ui-toolkit/src";
import CardLabelProfile from "./components/CardLabelProfile";
import {
  RiskReportSearchResultByMonth, getAllStrategy, getMyProfile,
  getPerformanceMetricsSearchResult, getFundDetails, uploadFileDeck,
  uploadTearSheet, updateInfo, updateTenantCompanyLogo, getCloudDecks, getAllMedia, GetRiskReportSearchResult, getInvestedCompaniesList, getAllocatorUserList
} from "./actions";
import { Row, Col, Empty, Tabs, Drawer, Avatar } from "antd";
import FundStatCard from "@hedgefund/shared/src/FundStatCard";
import FundTearSheet from "@hedgefund/shared/src/FundTearSheet";
import FundRiskReport from "@hedgefund/shared/src/FundRiskReport";
import FundDeck from "@hedgefund/shared/src/FundDeck";
import ReactModal from "@public/ui-toolkit/src/ReactModal";
import { useFormik } from "formik";
import * as Yup from "yup";
import { alertService } from "@hedgefund/shared/src/Alert";
import Stats from "@hedgefund/shared/src/Stats";
import { createFcnQuery } from "../ContactFCNAdmin/actions";
import { useQuery } from "../../utils/CustomHook";
import { myPost } from "./MyPosts/actions";
import { getMettingList } from "./MyMeetingsTab/actions";
import { useHistory } from "react-router";
import { getFundBioUsersAction, getInvestorList } from "../FundDetail/actions";
import Select from "react-select";
import { followAllocator } from "../AllocatorDetail/actions";

const CloudDocuments = [
  {
    name: "All Document",
    key: null
  },
  {
    name: "Presentation",
    key: 0
  },
  {
    name: "Investor Letters",
    key: 1
  },
  {
    name: "Firm Research",
    key: 2
  },
  {
    name: "Due Diligence Document",
    key: 3
  }
]
const CloudDocumentDropdown = [
  {
    name: "Presentation",
    key: 0
  },
  {
    name: "Investor Letters",
    key: 1
  },
  {
    name: "Firm Research",
    key: 2
  },
  {
    name: "Due Diligence Document",
    key: 3
  }
]
const investorColumns = [
  {
    name: "Comapny Name",
    key: "companyName",
  },
  {
    name: "Documents Count",
    key: "documents",
  },
];

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: "1px solid #212529",
    padding: 4,
  }),
  option: (base, state) => ({
    ...base,
    height: "100%",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#000",
  }),
  singleValue: (provided) => ({ ...provided, color: "#000" }),
  input: (styles) => ({ ...styles, color: "#000" }),
}
const Profile = () => {
  const query = useQuery();
  const tab = query.get("tab");
  const [activeTab, setActiveTab] = useState("nav-my-fund-list-tab");
  const history = useHistory();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [currentFund, setCurrentFund] = useState();
  const [hide, setHide] = useState(false);
  const [fundBio, setFundBio] = useState(false);
  const [docActiveTab, setDocActiveTab] = useState();


  const { meetings } = useSelector((state) => state.meetings);
  const myPostsState = useSelector((state) => state.getMyPosts);
  const { 
    myPosts, 
    // postCount, 
    // pageCount 
  } = myPostsState;

  const profileState = useSelector((state) => state.profile);
  const fundDetail = useSelector((state) => state.fundDetail);

  const {
    myProfileState,
    monthlyReturnPerformance,
    performanceMetrcisMonth,
    riskReportMonthList,
    reportExtractData,
    fundId,
    fund,
    fundDecks,
    fundMedia,
    fundStats,
    loading,
    pmLoading,
    tearSheetLoading,
    fileDeckLoading,
    stratagies,
    companyLogoUrl,
    mediaLoading,
    deckLoading,
    fundLoading,
    investedAllocator,
    allocatorLoading,
    allocatorUsers,
  } = profileState;
  const [currentFunds, setCurrentFunds] = useState(fundStats);

  useEffect(() => {
    if (fundId) {
      setCurrentFund(fundId);
      setCurrentFunds(fundStats);
      dispatch(GetRiskReportSearchResult({ id: fundId }));
      dispatch(getInvestorList(fundId));
    }
    if (tab) {
      setActiveTab(tab);
      onClickTab(tab);
    }
  }, [tab, fundId]);
  useEffect(() => {
    onClickTab(activeTab);
  }, [])
  const getCloudDocuments =(tabId) => {
    dispatch(getCloudDecks({
      recordId: myProfileState?.id,
      recordType: 1,
      docType : tabId
    }))
  }

  const onClickTab = (tabId) => {
    switch (tabId) {
      case "nav-my-fund-list-tab":
        dispatch(getMyProfile());
        setActiveTab(tabId);
        break;
      case "nav-my-meetings-tab":
        dispatch(getMettingList());
        setActiveTab(tabId);
        break;
      case "nav-media-tab":
        dispatch(getAllMedia({
          recordType: 4
        }))
        setActiveTab(tabId);
        break;
      case "nav-fund-docs-tab":
        getCloudDocuments(null);
        setActiveTab(tabId);
        break;
      case "nav-invested-allocator-tab":
        dispatch(getInvestedCompaniesList());
        setActiveTab(tabId);
        break;
      case "nav-news-feed-tab":
        dispatch(myPost());
        setActiveTab(tabId);
        break;
      default:
        break;
    }
  }

  const getAllocatorUsers = (id) => {
    dispatch(getAllocatorUserList(id))
  }

  const onFundDetail = (id) => {
    dispatch(getFundDetails(id));
  }

  const handleYearChange = (presentYear) => {
    dispatch(getPerformanceMetricsSearchResult({ id: fundId, year: presentYear }));
  };

  const handleReportChange = (riskReport) => {
    dispatch(RiskReportSearchResultByMonth(riskReport));
  };

  const onSuccessAlert = () => {
    alertService.success("Successfully uploaded!", { autoClose: true });
  };

  const onCloseModal = () => {
    setOpen(false);
    formik.resetForm();
  }
  const fitlerFunds = (val) => {
    const fundList = fundStats.filter(x => x.name.toLowerCase().includes(val.toLowerCase()));
    setCurrentFunds(fundList)
  }
  const formik = useFormik({
    initialValues: {
      file: "",
      recordId: "",
      docType: "",
    },
    validationSchema: Yup.object({
      docType: Yup.string().required("Document Type is required"),
      file: Yup.string().required("File Deck is required"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append(`Url`, values.file);
      formData.append(`RecordId`, myProfileState?.id);
      formData.append(`DocType`, values.docType);
      uploadFundDeck(formData);
    },
  });

  const uploadFundDeck = (values) => {
    dispatch(uploadFileDeck(values, onSuccessAlert, onCloseModal));
  };
  const onSuccess = (val) => {
    alertService.success("Successfully Created!", { autoClose: true });
  };

  const onSubmitNewPostHandler = (value) => {
    if (value) {
      dispatch(createFcnQuery(value, onSuccess));
    }
  };

  const updateTenantInfo = (values, onSuccessData) => {
    dispatch(updateInfo(values, onSuccessData));
  }
  const updateTenantLogoImage = (values, onSuccessData, onCloseModal) => {
    dispatch(updateTenantCompanyLogo(values, onSuccessData, onCloseModal));
  }
  const onClickDocumentTab = (tabId) => {
    getCloudDocuments(tabId);
    setDocActiveTab(tabId);
  }
  const onSuccessFollow =(follow) => {
    alertService.success(`Successfully ${follow ? "Followed" : "Un Follow"}!`, { autoClose: true });
  }
  const followFundHandler = (allocatorId, follow) => {
    dispatch(followAllocator(allocatorId, follow, onSuccessFollow(follow)))
  }
  return (
    <main>
      <div className="main-inner">
        <div className="mt-3">
          {!loading ? (
            <Row style={{ margin: "auto" }}>
              <Col span={7} style={{ minHeight: "800px", backgroundColor: "#fff", borderRadius: "10px", marginLeft: "30px", padding: "10px", border: "1px solid #edeef0" }}>
                <FCNProfileHeader
                  getAllStrategy={getAllStrategy}
                  companyLogoUrl={companyLogoUrl}
                  portal={'hedgefund'}
                  myProfileState={myProfileState}
                  stratagies={stratagies}
                  onSubmitNewPostHandler={onSubmitNewPostHandler}
                  updateInfo={updateTenantInfo}
                  updateTenantLogoImage={updateTenantLogoImage}
                />
              </Col>
              <Col span={16} style={{ backgroundColor: "#fff", borderRadius: "10px", marginLeft: "10px", border: "1px solid #edeef0" }}>
                <Row>
                  <Col span={24} style={{ backgroundColor: "#fff", padding: "10px 5px", position: "relative", borderRadius: "10px" }}>
                    <Tabs activeKey={activeTab} size="large" onTabClick={(e) => onClickTab(e)} type="card" items={[
                      {
                        key: "nav-my-fund-list-tab",
                        label: `My Funds`,
                        children: <>
                          <FundStatCard
                            isSearchEnable={true}
                            funds={currentFunds}
                            id={fundId}
                            notes={fund?.note} 
                            currentFund={currentFund}
                            setCurrentFund={setCurrentFund}
                            onClick={onFundDetail}
                            fitlerFunds={fitlerFunds}
                          />
                          {!fundLoading ? (
                            <>
                              <Row>
                                <Col span={24} className="mt-2" >
                                  <div className="blue-bar">
                                  <div  style={{ color: "#fff", margin: "0px", fontSize: "26px", fontWeight: "bold" }}>
                                    {(() => {
                                      if (fund?.isPrivate) {
                                        return (<i className="fa fa-lock mr-2" style={{ color: "red" }}></i>)
                                      } else {
                                        return (<i className="fa fa-globe mr-2" style={{ color: "#3ac1b5" }}></i>)
                                      }
                                    })()}
                                    Fund: {fund?.name}
                                    </div>
                                    <div className="investor-buttons">
                                      <button
                                        className="investor-button px-4 mr-3"
                                        onClick={() => {
                                          setHide(!hide);
                                        }}
                                      >
                                        Investors
                                      </button>
                                      <button
                                        className="investor-button px-4 mr-3"
                                        onClick={() => {
                                          dispatch(getFundBioUsersAction(myProfileState?.id))
                                          setFundBio(true);
                                        }}>
                                        Fund Bio's
                                      </button>

                                    {/* <Button
                                    btnName="Investors"
                                    btnType="!primary"
                                    iconClass="investor-button"
                                    btnStyle={{ backgroundColor : "#276598", padding : "0px", fontSize : "22px", border : "1px solid #276598", color : "#fff", float : "right" }}
                                    onClick={() => {
                                      setHide(!hide);
                                    }}
                                  />
                                   <Button
                                    btnName="Fund Bio's"
                                    btnType="!primary"
                                    className="investor-button"
                                    btnStyle={{ backgroundColor : "#276598", fontSize : "22px", padding : "0px", border : "1px solid #276598", color : "#fff", float : "right" }}
                                    onClick={() => {
                                      dispatch(getFundBioUsersAction(myProfileState?.id))
                                      setFundBio(true);
                                    }}
                                  /> */}
                                  </div>
                                  </div>
                                </Col>
                                {/* <Col span={2} className="mt-2 ml-2" >
                                 
                                </Col> */}
                              </Row>
                              <Row>
                                {fund?.status === 2 && (
                                  <Col span={23} className="ml-2 mr-2">
                                    {
                                      <div className={`expandable ${hide}-animation`}>
                                        <div
                                          className=" d-flex
                                           flex-wrap
                                           justify-content-between
                                            align-items-center "
                                        >
                                          <div className="mr-3">
                                            <h5 className="mb-0"> Investors</h5>
                                          </div>
                                        </div>

                                        <div>
                                          <CardWithLable title={"Invested Funds"}>
                                            <div className="hf-card2-body px-0 pb-0">
                                              <div className="hf-table">
                                                <Table
                                                  columns={investorColumns}
                                                  NoFound={"No Invested Fund Found"}
                                                  data={fundDetail?.investorList}
                                                  onRowClick={(row) =>
                                                    history.push(`/document/${row.id}`)
                                                  }
                                                />
                                              </div>
                                            </div>
                                          </CardWithLable>
                                        </div>
                                      </div>
                                    }
                                  </Col>
                                )}
                                <Col span={12} className="mt-2" style={{ textAlign: "end", backgroundColor: "#dbecff", padding: "10px 5px", position: "relative", borderRadius: "10px" }}>
                                <Tabs defaultActiveKey={"1"} id="" size="large" type="card" items={[
                                  {
                                  key: "1",
                                  id: "nav-addtional-notes-tab",
                                  label: `Additional Notes`,
                                  children:
                                    <Col span={23} className="ml-3 mt-2" style={{ textAlign: "left" }}>
                                      <p>{fund?.note ? fund?.note : <div style={{ textAlign: "center" }}><Empty /></div>}</p>
                                    </Col>
                                },
                                {
                                  key: "2",
                                  id: "nav-fund-overview-tab",
                                  label: `Fund Overview`,
                                  children:
                                    <Col span={23} className="ml-3 mt-2" style={{ textAlign: "left" }}>
                                      {fund?.description ? <p dangerouslySetInnerHTML={{ __html: fund?.description }} /> :  <div style={{ textAlign: "center" }}><Empty /></div>}
                                    </Col>
                                },
                                // {
                                //   key: "3",
                                //   id: "nav-fund-bio-tab",
                                //   label: `Fund Bio`,
                                //   children:
                                //     <Col span={23} className="ml-3 mt-2" style={{ textAlign: "left" }}>
                                //       {fund?.description ? <p dangerouslySetInnerHTML={{ __html: fund?.description }} /> :  <div style={{ textAlign: "center" }}><Empty /></div>}
                                //     </Col>
                                // },
                                {
                                  key: "3",
                                  id: "nav-admin-note-tab",
                                  label: `Admin Note`,
                                  children:
                                    <Col span={23} className="ml-3 mt-2" style={{ textAlign: "left" }}>
                                      <p>{fund?.adminNote ? fund?.adminNote : <div style={{ textAlign: "center" }}><Empty /></div>}</p>
                                    </Col>
                                }
                              ]} />
                            </Col>
                            <Col span={12} className="mt-2" style={{ textAlign: "end", backgroundColor: "#fff", padding: "10px 5px", position: "relative", borderRadius: "10px" }}>
                              <Stats
                                showStrategy={true}
                                fundName={myProfileState?.name}
                                ytdValue={fundId === window._env_.EthosFundId ? `${fund?.ytd}%*` : `${fund?.ytd}%`}
                                latestMonthValue={`${fund?.monthlyReturn}%`}
                                annualReturnsValue={fundId === window._env_.EthosFundId ? `` : `${fund?.annualizedReturn}%`}
                                annualVolatilityValue={fundId === window._env_.EthosFundId ? `` : `${fund?.annualVolatility}`}
                                strategyValue={fund?.strategyName}
                                subStrategyValue={fund?.subSpecialtyName}
                              />
                            </Col>
                          </Row>
                          <FundTearSheet
                            fundId={currentFund}
                            fund={fund}
                            handleYearChange={handleYearChange}
                            getPerformanceMetricsSearchResult={getPerformanceMetricsSearchResult}
                            performanceMetrcisMonth={performanceMetrcisMonth}
                            monthlyReturnPerformance={monthlyReturnPerformance}
                            tearSheetLoading={tearSheetLoading}
                            uploadTearSheet={uploadTearSheet}
                            loading={loading}
                            portal={"hedgefund"}
                          />
                          <FundRiskReport
                            fundId={fundId}
                            fund={fund}
                            reportExtractData={reportExtractData}
                            riskReportMonthList={riskReportMonthList}
                            handleReportChange={handleReportChange}
                            pmLoading={pmLoading}
                            portal={"hedgefund"}
                          />
                            </>
                          ) : (
                            <Row className="text-center">
                              <Col span={24}>
                                <Spinner />
                              </Col>
                            </Row>
                          )}
                          
                        </>
                      },
                      {
                        key: "nav-my-meetings-tab",
                        label: `My Meetings`,
                        children: <>
                          <div className="mt-2">
                            <div className="stylish-title text-blue Fund-FontSize">My Meetings</div>
                          </div>
                          <CardLabelProfile>
                            <div className="table-responsive hf-table py-3">
                              {/* <MyMeetingsTab /> */}
                              <MyMeetings meetings={meetings} portal="hedgefund" />;
                            </div>
                          </CardLabelProfile>
                        </>
                      },
                      {
                        key: "nav-media-tab",
                        label: `My Media`,
                        children: <>
                          <div className="stylish-title text-blue mt-2 Fund-FontSize">{"My Media"}</div>
                          <CardLabelProfile>
                            <div className="table-responsive hf-table">
                              <VideoModal myFundDetails={fundMedia} mediaLoading={mediaLoading} portal="hedgefund" />
                            </div>
                          </CardLabelProfile>
                        </>
                      },
                      {
                        key: "nav-fund-docs-tab",
                        label: `My Document Cloud`,
                        children: <>
                          <Row><Col span={20} >
                            <div className="stylish-title text-blue mt-2 Fund-FontSize">{"Document Cloud"}</div>
                          </Col>
                            <Col span={4} >
                              <Button
                                btnName="Upload Pdf"
                                btnType="!primary"
                                iconClass="fa fa-download mr-2"
                                onClick={() => setOpen(true)}
                                type="button"
                              />
                            </Col></Row>
                          <Col span={24} >
                            <ReactModal open={open} onClose={() => setOpen(false)} center title={"Upload File Deck"} >
                              <form onSubmit={formik.handleSubmit}>
                                <div className="modal-body">
                                  <Row gutter={[12, 12]}>
                                <Col span={24}>
                              <Select
                                styles={customStyles}
                                defaultValue={"Select Document Type"}
                                onChange={(e) => {
                                  formik.setFieldValue("docType", e.value)
                                }}
                                options={CloudDocumentDropdown.map((item) => {
                                  return {
                                    value: item?.key,
                                    label: item?.name,
                                  };
                                })}
                              />
                              {formik.touched.docType &&
                                formik.errors.docType ? (
                                <div className="form-error-message">
                                  {formik.errors.docType}
                                </div>
                              ) : null}
                            </Col>
                            <Col span={24}>
                                  <Input
                                    type="file"
                                    id="file"
                                    name="file"
                                    onChange={(e) =>
                                      formik.setFieldValue("file", e.target.files[0])
                                    }
                                    accept=".pdf"
                                  />
                                  {formik.touched.file &&
                                    formik.errors.file ? (
                                    <div className="form-error-message">
                                      {formik.errors.file}
                                    </div>
                                  ) : null}
                                  </Col>
                                  </Row>
                                </div>
                                <div className="modal-footer d-block text-center">
                                  <Button
                                    btnName="Upload"
                                    btnType="primary"
                                    loading={fileDeckLoading}
                                    type="submit"
                                  />
                                </div>
                              </form>
                            </ReactModal>
                            <Col span={24}>
                              <Tabs
                                activeKey={docActiveTab}
                                className="custom-tabs"
                                size="large"
                                onTabClick={(e) => onClickDocumentTab(e)}
                                type="card"
                                items={CloudDocuments?.map((item, index) => {
                                  return {
                                    label: item.name,
                                    key: item.key,
                                    children:
                                      <FundDeck
                                        portal="hedgefund"
                                        decks={fundDecks}
                                        deckLoading={deckLoading}
                                      />
                                  };
                                })}
                              />
                            </Col>
                            {/* <FundDeck
                              decks={fundDecks}
                              deckLoading={deckLoading}
                              portal={"hedgeFund"}
                            /> */}
                          </Col>
                        </>
                      },
                      {
                        key: "nav-news-feed-tab",
                        label: `My News Feed`,
                        children: <>
                          <div className="stylish-title text-blue mt-2 mb-2 Fund-FontSize">{"My Posts"}</div>
                          <NewsFeedComponent
                            showButton={false}
                            loading={loading}
                            getPosts={myPosts}
                            type={false}
                            editDeleteIcon={false}
                          />
                        </>
                      },
                      {
                        key: "nav-invested-allocator-tab",
                        label: `My Allocator`,
                        children: <>
                          <div className="stylish-title text-blue mt-2 Fund-FontSize mb-3">{"My Allocator"}</div>
                          {!allocatorLoading ? (
                            <Row gutter={[24, 24]}>
                              {investedAllocator.map((allocator) => (
                                <Col span={8} className="p-3">
                                  <SearchAllocatorsCard
                                    allocator={allocator}
                                    logo={allocator?.logo}
                                    isFooterShow= {true}
                                    getAllocatorUsers={getAllocatorUsers}
                                    allocatorUsers={allocatorUsers}
                                    followFundHandler={followFundHandler}
                                  />
                                </Col>
                              ))}
                            </Row>
                          ) : (
                            <Spinner />
                          )}
                        </>
                      },
                    ]} />
                  </Col>
                </Row>
              </Col>
            </Row>
          ) : (
            <Row style={{ textAlign: "center" }}>
              <Col span={24} >
                <Spinner />
              </Col>
            </Row>)}
          <VideoIframe myFundDetails={myProfileState} />
        </div>
        <Drawer title="Fund Bio's" open={fundBio} onClose={() => setFundBio(false)} width={500}  >
          <Row>
            <Col span={24} className="mt-2 bg-light">
              {!fundDetail.bioLoading ? (
                fundDetail?.fundBioUsers?.map((user) => {
                return (
                  <Row style={{ margin: "5px 0px", borderLeft: "3px solid #9f9f9f" }}>
                    <Col span={4} className="text-center">
                      <Avatar src={user?.profileImage} style={{ height: "50px", width: '50px' }} size={"large"} />
                    </Col>
                    <Col span={19} >
                      <Row>
                        <Col span={24} >
                          <span className="font-weight-bold"> {user?.fullName} </span>
                        </Col>
                        <span className="text-secondary" style={{ fontSize: "11px" }}> {user?.title}</span>

                        <Col span={24}>
                          <p dangerouslySetInnerHTML={{ __html: user?.highlight ? user?.highlight : "N/A" }} />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )
              })) : (
                <Spinner />
              )}
            </Col>
          </Row>
        </Drawer>
      </div>
    </main>
  );
};

export default Profile;
